export const TermsTranslations = {
  en: {
    terms: {
      title: "Terms and Conditions",
      backToLogin: "Back to login",
    },
  },
  es: {
    terms: {
      title: "Términos y condiciones",
      backToLogin: "Volver al inicio de sesión",
    },
  },
};
